module.exports = __webpack_public_path__ + "img/plant_5_mobile.a978ec1c.webp";